"use client";
import {gridItemVariants} from "@/lib/animations";
import {motion} from "framer-motion";

interface MissionandVissionBlockProps {
    vision?: {
        subTitle?: string;
        title?: string;
        description?: string;
    };
    mission?: {
        subTitle?: string;
        title?: string;
        description?: string;
    };
}

export default function MissionandVissionBlock({
    vision = {
        subTitle: "Vision",
        title: "Our Vision",
        description: "We see a world in which there will be constant change in the tourism sector in the coming years. For this reason, we dynamically offer programs and alternative programs and fast solutions to our guests in advance, responding to the demands and new trends of tourists from various countries and always guaranteeing service quality and personalized attention, by taking advantage of the opportunities of the digital age. To continue our way as a permanent and respected personal and corporate tourism brand in the sector with reliable, fast and economical solutions by ensuring 100% customer and staff satisfaction."
    },
    mission = {
        subTitle: "Mission",
        title: "Our Mission",
        description: "We see a world in which there will be constant change in the tourism sector in the coming years. For this reason, we dynamically offer programs and alternative programs and fast solutions to our guests in advance, responding to the demands and new trends of tourists from various countries and always guaranteeing service quality and personalized attention, by taking advantage of the opportunities of the digital age. To continue our way as a permanent and respected personal and corporate tourism brand in the sector with reliable, fast and economical solutions by ensuring 100% customer and staff satisfaction."
    }
}: MissionandVissionBlockProps = {}) {
    return (
        <motion.div
            variants={gridItemVariants}
            className="bg-white bg-alsero-map-decor"
        >
            <div className="mx-auto flex w-full min-w-0 max-w-9/12 flex-col gap-12 px-4 py-16 sm:gap-16 sm:px-6 md:gap-20 lg:py-32 xl:gap-24 xl:py-[160px]">
                {/* Vision Section */}
                <section className="flex w-full max-w-full flex-col items-stretch gap-10 lg:flex-row lg:items-start lg:gap-16 xl:gap-24">
                    <div className="flex min-w-0 flex-1 flex-col gap-6">
                        <p data-prop-path="vision.subTitle" className="font-display text-xl text-alsero-first sm:text-2xl md:text-3xl xl:text-5xl">{vision.subTitle || "Vision"}</p>
                        <h2 data-prop-path="vision.title" className="text-2xl font-bold text-alsero-dark-gray sm:text-3xl md:text-4xl xl:text-7xl">{vision.title || "Our Vision"}</h2>
                        <p data-prop-path="vision.description" className="text-base leading-relaxed text-alsero-light-gray sm:text-lg">{vision.description || ""}</p>
                    </div>
                    <div className="flex w-full shrink-0 justify-center lg:w-auto lg:max-w-[min(100%,459px)] lg:justify-end">
                        <svg className="h-auto w-full max-w-[459px]" width="459" height="191" viewBox="0 0 459 191" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                            <path d="M458.531 190.65C434.319 110.196 372.521 42.4532 286.657 14.1993C182.892 -19.945 73.1609 13.1844 4.72563 89.7287M4.72563 89.7287L1.14864 71.2103M4.72563 89.7287L23.443 92.8703" stroke="#022A3A" strokeDasharray="10 10"/>
                        </svg>
                    </div>
                </section>
                {/* Mission Section */}
                <section className="flex w-full max-w-full flex-col items-stretch gap-10 self-end lg:flex-row-reverse lg:items-start lg:gap-16 xl:gap-24">
                    <div className="order-1 flex min-w-0 flex-1 flex-col gap-6 lg:order-none">
                        <p data-prop-path="mission.subTitle" className="font-display text-xl text-alsero-first sm:text-2xl md:text-3xl xl:text-5xl">{mission.subTitle || "Mission"}</p>
                        <h2 data-prop-path="mission.title" className="text-2xl font-bold text-alsero-dark-gray sm:text-3xl md:text-4xl xl:text-7xl">{mission.title || "Our Mission"}</h2>
                        <p data-prop-path="mission.description" className="text-base leading-relaxed text-alsero-light-gray sm:text-lg">{mission.description || ""}</p>
                    </div>
                    <div className="order-0 flex w-full shrink-0 justify-center lg:order-none lg:w-auto lg:max-w-[min(100%,459px)] lg:justify-start">
                        <svg className="h-auto w-full max-w-[459px]" width="459" height="192" viewBox="0 0 459 192" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                            <path d="M0.59758 0.675798C24.8096 81.1295 86.607 148.873 172.471 177.126C276.237 211.271 385.967 178.141 454.403 101.597M454.403 101.597L457.98 120.115M454.403 101.597L435.685 98.4554" stroke="#022A3A" strokeDasharray="10 10"/>
                        </svg>
                    </div>
                </section>
            </div>
        </motion.div>
    );
}